import moment from 'moment';
import React from 'react';

import { formatMoney } from '../../shared/format';

function renderOptions({ value }) {
	return !value ? '-' : (
		<div>
			{value.map((o, i) => (
				<div key={i}>{o.label}</div>
			))}
		</div>
	);
}

function renderPeriod(_, { row }) {
	return (
		<div>
			<div>{moment(row.starts_at).format('DD.MM.YY')}</div>
			<div>{moment(row.ends_at).format('DD.MM.YY')}</div>
		</div>
	);
}

function renderActions(_, { row, updateById, removeById }) {
	return (
		<div className='action-list'>
			<a
				className='banners-edit-icon'
				onClick={() => updateById(row.id)}
			/>
			<a
				className='remove-icon'
				onClick={() => {
					if (confirm('Delete activity?')) {
						removeById(row.id);
					}
				}}
			/>
		</div>
	);
}

export default [
	[
		{
			index: 'id',
			header: {
				title: 'ID'
			},
			column: {}
		},
		{
			index: 'name',
			header: {
				title: 'Name'
			},
			column: {}
		},
		{
			index: 'offers',
			header: {
				title: 'Offers'
			},
			column: {
				render: renderOptions
			}
		},
		{
			index: 'countries',
			header: {
				title: 'Geos'
			},
			column: {
				render: renderOptions
			}
		},
		{
			index: 'tag',
			header: {
				title: 'Tag'
			},
			column: {}
		},
		{
			index: 'utm_source',
			header: {
				title: 'UTM source'
			},
			column: {}
		},
		{
			index: 'utm_medium',
			header: {
				title: 'UTM medium'
			},
			column: {}
		},
		{
			index: 'utm_campaign',
			header: {
				title: 'UTM campaign'
			},
			column: {}
		},
		{
			index: 'utm_term',
			header: {
				title: 'UTM term'
			},
			column: {}
		},
		{
			index: 'utm_content',
			header: {
				title: 'UTM content'
			},
			column: {}
		},
		{
			index: 'type',
			header: {
				title: 'Type'
			},
			column: {}
		},
		{
			index: 'price',
			header: {
				title: 'Price'
			},
			column: {
				format: formatMoney
			}
		},
		{
			index: 'period',
			header: {
				title: 'Period'
			},
			column: {
				render: renderPeriod
			}
		},
		{
			index: 'comment',
			header: {
				title: 'Comment'
			},
			column: {}
		},
		{
			index: 'actions',
			header: {
				title: 'Actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/activity/table-initial-data.js